import { render, staticRenderFns } from "./Default_Ball.vue?vue&type=template&id=3a8b111c&scoped=true"
import script from "./Default_Ball.vue?vue&type=script&lang=js"
export * from "./Default_Ball.vue?vue&type=script&lang=js"
import style0 from "./Default_Ball.vue?vue&type=style&index=0&id=3a8b111c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b111c",
  null
  
)

export default component.exports